import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { useEffect, useState } from 'react';
import ContractorClientForm from '../contractor_client_form/ContractorClientForm';
import {
	contractorClientsRestCrudThunksForBuyer,
	contractorClientsRestCrudThunksForSupplier,
} from '../../thunks/contractor_clients_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { Card, Col, Row } from 'antd';
import { generateBackLink, goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
const queryString = require('qs');

const DEFAULT_BACK_LINK_TO = (userType) => `/${userType}/contractor_clients/overview`;
const DEFAULT_BACK_LINK_TEXT = 'Back to clients';

function EditContractorClientPage({ getContractorClient, userType, match, clearNavbar }) {
	const [loading, setLoading] = useState(false);
	const [contractorClientDetail, setContractorClientDetail] = useState({});

	const { id } = match.params;

	const location = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (id) {
			setLoading(true);
			getContractorClient(id).then((client) => {
				setContractorClientDetail(client);
				setLoading(false);
			});
		}
		clearNavbar();
	}, []);

	return loading ? null : (
		<>
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<h5 style={{ marginBottom: 24 }}>{id ? '' : 'New '}Contractor Client</h5>
							<ContractorClientForm
								formData={contractorClientDetail}
								loading={loading}
								onSuccess={(rec) => {
									const defaultUrlPath = `/${userType}/contractor_clients/detail/${rec.id}/details`;
									let string = goBackLink(location, defaultUrlPath);
									const [path, queryParams] = string.split('?');
									let urlSearchParams = queryString.parse(queryParams);
									history.replace(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
								}}
								onCancel={() => {
									history.goBack();
								}}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</>
	);
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getContractorClient: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? contractorClientsRestCrudThunksForSupplier.readOne(id)
				: contractorClientsRestCrudThunksForBuyer.readOne(id)
		),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditContractorClientPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
